<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import qs from 'querystring'
export default {
  async created () {
    // vue $route.query 抓不到
    let code = this.$route.query.code || qs.parse(window.location.search).code

    if (code) {
      this.$router.push({
        path: '/loading'
      })
      await this.wxLogin(code)
      return
    }
    // prevent localStorage.setItem exception on private browsering
    // https://stackoverflow.com/questions/40873498/error-the-quota-has-been-exceeded-on-safari-ios-10
    try {
      let k = '__testLocalStorage'
      localStorage.setItem(k, k)
      localStorage.removeItem(k)
    } catch (e) {
      localStorage.getItem = () => {}
      localStorage.setItem = () => {}
      localStorage.removeItem = () => {}
      localStorage.clear = () => {}
    }
  },
  methods: {
    async wxLogin (code) {
      try {
        let user = await this.$store.dispatch('api/ranch/userSignIn', {uid: code})
        console.log('wxLogin', user)
        if (window.parent) {
          window.parent.location.reload()
        } else {
          // TODO to show failure page?
          // console.error('origin', window.location.origin, `https://${window.location.hostname}`)
          // window.location.href = `https://${window.location.hostname}`
        }
      } catch (e) {
        console.error(e)
      }
    }
  }
}
</script>

<style src="./style/reset.css"></style>
<style src="./style/weui.min.css"></style>
<style lang="postcss">
@import "var.css";
/* override fontello */
[class^="icon-"]:before, [class*=" icon-"]:before {
  margin-right: 0;
  margin-left: 0;
}
.invisible {
  position: absolute;
  visibility: hidden;
  width: 0;
  height: 0;
  margin: 0;
  padding: 0;
  border: 0;
}
/* @see https://cn.vuejs.org/css/page.css */
#app,
.weui,
.weui-loading_toast {
  /* font-family: "Source Sans Pro", "Helvetica Neue", Arial, sans-serif; */

  /* alike nutsbp.com */
  font-family: "PingFang SC", "Helvetica Neue For Number", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue, Helvetica", Arial, sans-serif;

  -webkit-font-smoothing: antialiased;
  -webkit-overflow-scrolling: touch;
  -moz-osx-font-smoothing: grayscale;
}
#app {
  color: var(--colorBlack1);
  background-color: var(--colorWhite);

  @media (--mediaPc) {
    font-size: var(--textSize4);
  }
  @media (--mediaMobile) {
    font-size: var(--textSize4Mobile);
  }
  & a {
    color: var(--colorBlack1);
  }
  & *:disabled {
    cursor: not-allowed;
  }
  /* custom animation */
  & .custom-fade-enter-active,
  & .custom-fade-leave-active {
    transition: opacity .5s;
  }
  & .custom-fade-enter,
  & .custom-fade-leave-to {
    opacity: 0;
  }
}
.weui.picker {
  position: fixed;
  z-index: 9999;
}
.weui-toast {
  z-index: 9999;
  min-height: 2em;

  @media (--mediaPc) {
    top: 35%;
  }
  @media (--mediaMobile) {
    top: 25%;
  }

  & .weui-icon_toast.weui-icon-success-no-circle {
    display: none;
  }
}
.weui-loading_toast {
  position: fixed;
  z-index: 9999;
}
.weui-toast__content {;
  margin: 8px;
  font-size: 14px;
  word-break: break-word;
}
.weui-picker__action {
  color: var(--colorMain);
}
</style>



// WEBPACK FOOTER //
// src/App.vue